import React from 'react';
import { useState } from 'react';

const FAQ = () => {
  const faqs = [
    {
      question: "Is this tool really completely free?",
      answer: "Yes! Our basic background removal service is completely free. For professional users who need more advanced features, we also offer paid upgrade options."
    },
    {
      question: "How does AI background removal work?",
      answer: "Our AI uses advanced deep learning algorithms to detect and separate foreground subjects from backgrounds. The system automatically analyzes image textures, edges, and colors to achieve precise, intelligent background removal."
    },
    {
      question: "What image formats are supported?",
      answer: "We support all common image formats, including JPG, PNG, WEBP, and more. You can export the processed results as PNG with transparent backgrounds or JPG with white backgrounds."
    },
    {
      question: "Is my image data secure?",
      answer: "Absolutely secure! All image processing is done locally in your browser, and images are never uploaded to any servers, ensuring 100% privacy and security of your data."
    },
    {
      question: "Can I process multiple images at once?",
      answer: "Yes! Our batch processing feature supports processing multiple images simultaneously, greatly improving your workflow efficiency."
    },
    {
      question: "How's the quality of processed images?",
      answer: "We use the latest AI technology to ensure processed images have smooth, natural edges and retain complete details, fully meeting commercial usage standards."
    },
    {
      question: "Do I need professional Photoshop skills?",
      answer: "Not at all! Our tool is designed to be simple and intuitive - you can achieve professional-grade background removal with just a few clicks."
    }
  ];

  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent sm:text-4xl">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-xl text-gray-500">
            Everything you need to know about our service
          </p>
        </div>

        <div className="mt-12 max-w-3xl mx-auto">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
              >
                <button
                  className="w-full px-6 py-4 text-left focus:outline-none"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <div className="flex items-center justify-between">
                    <span className="font-medium text-gray-900">{faq.question}</span>
                    <span className="ml-6 flex-shrink-0">
                      <svg
                        className={`w-6 h-6 transform ${
                          openIndex === index ? 'rotate-180' : ''
                        } transition-transform duration-300`}
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </span>
                  </div>
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-4">
                    <p className="text-gray-600">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Contact Support */}
        <div className="mt-12 text-center">
          <p className="text-gray-600">
            Have more questions? {' '}
            <a href="mailto:support@RemoveBackground.online" className="text-blue-600 hover:text-blue-500 font-medium">
              Contact our support team
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQ;